function Deletesteps() {
  return (
    <div class='container'>
      <p>За да изтриете акаунтът ви, моля влезте в апликацията в меню профил и използвайте бутона изтрий.</p>
      <p>Всичките ви данни включително имейл, категории, разпределения и снимки ще бъдат изтрити.</p>
      <p>Данните не могат да бъдат възстановени на по - късен етап.</p>
    </div>
  );
}

export default Deletesteps;
